import { useCallback, useState } from "react";
import { AreaMaterialSnapshot } from "../types";

type UseAreaMaterialMappingUiResult = Readonly<{
  isAreaMaterialMappingOpen: boolean;
  openAreaMaterialMappingModal: () => void;
  closeAreaMaterialMappingModal: () => void;
  editingSnapshot: AreaMaterialSnapshot | null;
  startEditingSnapshot: (snapshot: AreaMaterialSnapshot) => void;
  clearEditingSnapshot: () => void;
  closeAll: () => void;
}>;

/**
 * Hook for managing area-material mapping modal UI state.
 */
export const useAreaMaterialMappingUi = (): UseAreaMaterialMappingUiResult => {
  const [isAreaMaterialMappingOpen, setIsAreaMaterialMappingOpen] =
    useState(false);
  const [editingSnapshot, setEditingSnapshot] =
    useState<AreaMaterialSnapshot | null>(null);

  const openAreaMaterialMappingModal = useCallback(() => {
    setIsAreaMaterialMappingOpen(true);
  }, []);

  const closeAreaMaterialMappingModal = useCallback(() => {
    setIsAreaMaterialMappingOpen(false);
  }, []);

  const startEditingSnapshot = useCallback((snapshot: AreaMaterialSnapshot) => {
    setEditingSnapshot(snapshot);
  }, []);

  const clearEditingSnapshot = useCallback(() => {
    setEditingSnapshot(null);
  }, []);

  const closeAll = useCallback(() => {
    setIsAreaMaterialMappingOpen(false);
    setEditingSnapshot(null);
  }, []);

  return {
    isAreaMaterialMappingOpen,
    openAreaMaterialMappingModal,
    closeAreaMaterialMappingModal,
    editingSnapshot,
    startEditingSnapshot,
    clearEditingSnapshot,
    closeAll,
  };
};
